import { Popover as ReactTinyPopover, ArrowContainer } from "react-tiny-popover";
import React, { useRef } from "react";

import "../style/card.scss";
import "../style/shadows.scss";
import "../style/zindexes.scss";

/**
 * Relative positioned popover component.
 * Uses the brand guideline for styling.
 *
 * @param {object} props - React props object
 * @param {boolean} props.isOpen - Determines if the popover is open or not.
 * @param {function} props.onClickOutside - Callback function for when the user clicks outside the popover.
 * @param {ReactElement} props.content - The content to be displayed inside the open popover.
 * @param {boolean} props.showArrow - Determines if the open popover container should have an arrow pointing to the anchor element.
 * @param {string} props.contentClassName - CSS class names to be added to the popover content.
 * @param {ReactElement} props.children - The element that will be used as the anchor for the popover.
 */
function Popover({
    isOpen,
    onClickOutside,
    content,
    showArrow,
    contentClassName = "card card--xs shadow-lg",
    contentStyle = {},
    children,
}) {
    const parentRef = useRef();

    const mergedContentStyle = {
        ...contentStyle,
        margin: "-1.3px", //stops the arrow being too off to one side and having a gap due to the rounding of the card
    };

    const renderContent = ({ position, childRect, popoverRect }) => (
        <ArrowContainer
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            arrowColor={"var(--colors-base-00)"} //todo: set to same color as bg, incase its not white
            arrowSize={showArrow ? 11 : 0}
        >
            <div
                className={contentClassName} //need to set this here instead of on ArrowContainer, because that effects the arrow too
                style={mergedContentStyle}
            >
                {content}
            </div>
        </ArrowContainer>
    );

    return (
        <ReactTinyPopover
            isOpen={isOpen}
            onClickOutside={onClickOutside}
            content={renderContent}
            positions={["top", "bottom", "left", "right"]}
            align="start"
            padding={8}
            parentElement={parentRef.current}
            containerStyle={{
                zIndex: "var(--z-index-overlay-high)",
            }}
        >
            <div ref={parentRef}>{children}</div>
        </ReactTinyPopover>
    );
}

export default Popover;
